<template>
    <CardContentPanel icon="check-circle" v-bind="{action, index}">
        <template #title>{{ $t('projectclient.projectview.activity.pending.actions.CONFIRM_INVOICED_PROJECT_COMPLETION.title') }}</template>
        <template #body="{freelancerName}">
            {{ $t('projectclient.projectview.activity.pending.actions.CONFIRM_INVOICED_PROJECT_COMPLETION.description', {0: freelancerName}) }}
        </template>
        <template #actions>
            <NuxtLink :to="{name: 'project-projectId-validation', query: {origin: 'project-view'}}" data-testid="pending-action-card-cta-primary">
                <VJoyButton variant="main" size="small">
                    {{ $t('projectclient.projectview.activity.pending.actions.CONFIRM_INVOICED_PROJECT_COMPLETION.action.primary') }}
                </VJoyButton>
            </NuxtLink>
        </template>
    </CardContentPanel>
</template>

<script setup lang="ts">
    import {VJoyButton} from '@maltjoy/core-vue';
    import CardContentPanel from '../../CardContentPanel.vue';
    import type {ActivityPendingActionByType} from '@/features/project-view';

    defineProps<{
        action: ActivityPendingActionByType<'CONFIRM_INVOICED_PROJECT_COMPLETION'>;
        index: number;
    }>();
</script>
